/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { loadStatus } from "constants/enums";
import { getTotalPages } from "selectors/documentSelectors";
import { getPageBitmapSize, getPageLoadStatus } from "selectors/pageSelectors";

export const sizeOfPagesLoaded = stores => {
  const totalPages = getTotalPages(stores);
  let totalBitmapSize = 0;
  for (let i = 0; i < totalPages; ++i) {
    if (getPageLoadStatus(stores, i) === loadStatus.LOADED) {
      totalBitmapSize += getPageBitmapSize(stores, i);
    }
  }
  return totalBitmapSize;
};
